export const activitySteps = [
  {
    label: "Register:",
    description: `Registration gets your child into the contest, ergo, making your child
          Kiddies Crown Contestant.`,
  },
  {
    label: "Campaign:",
    description: `When the contest commences, a campaign poster will be sent to you.
          The poster is intended to help your child campaign for vote from
          families and friends.`,
  },
  {
    label: "Vote:",
    description: `Voting is the sole determinate to your child's victory, we advise campaigning 
          and voting as much as possible, even after you've gotten the required number of votes, this
          will in turn give you an edge at the final.`,
  },
  {
    label: "Win:",
    description: `The contestant with the highest accumulated number of votes emerges as the winner.
          The grand winner will be given a cash prize of N2,000,000, Mr/Miss Crown 2025, Family package and other wonderful prizes. The 2nd and 3rd position gets N1,000,000 and N500,000 cash prizes, other great prizes There'll also be
          consolation prizes for the top 5 contestants.`,
  },
];
